export default "__VITE_ASSET__DfUPxTnP__"